import React, { useEffect, useState } from "react";
import { getMatchedRide } from "../services/api";

const formatDate = (value) => {
  if (!value) return "—";
  try {
    return new Intl.DateTimeFormat(undefined, { dateStyle: "medium", timeStyle: "short" }).format(new Date(value));
  } catch {
    return String(value);
  }
};

const MatchedRideModal = ({ open, onClose, telegramId, onCancel, rideId }) => {
  const [details, setDetails] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const load = async () => {
      if (!open || !telegramId) return;
      try {
        setLoading(true);
        setError(null);
        const res = await getMatchedRide(telegramId);
        if (!res?.success) throw new Error(res?.error || "Failed to load ride details");
        setDetails(res.data || null);
      } catch (e) {
        setError(e.message || "Failed to load ride details");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [open, telegramId]);

  if (!open) return null;

  const d = details;
  const driver = d?.driver;

  const telHref = driver?.phone ? `tel:${driver.phone}` : undefined;
  const tgHref = driver?.username ? `https://t.me/${driver.username.replace(/^@/, "")}` : undefined;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4">
      <div className="w-full max-w-lg rounded-xl border border-white/10 bg-neutral-950 p-5 shadow-2xl shadow-black/60">
        <div className="mb-4 flex items-center justify-between">
          <h2 className="text-lg font-semibold text-white">Your Ride Details</h2>
          <button onClick={onClose} className="bw-btn-ghost">✕</button>
        </div>

        {error && <div className="mb-3 rounded border border-white/20 bg-transparent px-3 py-2 text-sm bw-muted italic">{error}</div>}
        {loading ? (
          <div className="text-sm bw-muted">Loading details...</div>
        ) : !d ? (
          <div className="text-sm bw-muted">No matched ride at the moment.</div>
        ) : (
          <div className="space-y-3 text-sm text-white/90">
            <div className="flex items-center justify-between">
              <span className="bw-chip bw-chip-matched">{String(d.status || '').toUpperCase()}</span>
              <span className="bw-muted">{formatDate(d.timeOfRide)}</span>
            </div>
            <div>
              <p><span className="font-medium text-white/80">From:</span> <span className="italic">{d.pickupLocationName}</span></p>
              <p><span className="font-medium text-white/80">To:</span> <span className="italic">{d.dropLocationName}</span></p>
              {typeof d.bid === 'number' && (
                <p><span className="font-medium text-white/80">Fare:</span> <span className="italic">${d.bid.toFixed(2)}</span></p>
              )}
            </div>

            <div className="rounded border border-white/10 p-3">
              <p className="mb-2 text-white font-medium">Driver</p>
              <p>Name: {driver?.name || '—'}</p>
              <p>Phone: {driver?.phone || '—'}</p>
              {driver?.car && (
                <p>Car: {(driver.car.make || '') + ' ' + (driver.car.model || '')} {driver.car.color ? `(${driver.car.color})` : ''}</p>
              )}
            </div>

            <div className="mt-3 flex items-center gap-2">
              {telHref && (
                <a href={telHref} className="bw-btn" rel="noreferrer">Call Driver</a>
              )}
              {tgHref && (
                <a href={tgHref} className="bw-btn-ghost" target="_blank" rel="noreferrer">Message on Telegram</a>
              )}
              <button type="button" onClick={() => onCancel?.({ id: rideId })} className="bw-btn-ghost">Cancel Ride</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MatchedRideModal;
